import { render, staticRenderFns } from "./compression-data-bjsz2.vue?vue&type=template&id=70e8d1b6&scoped=true"
import script from "./compression-data-bjsz2.vue?vue&type=script&lang=js"
export * from "./compression-data-bjsz2.vue?vue&type=script&lang=js"
import style0 from "./compression-data-bjsz2.vue?vue&type=style&index=0&id=70e8d1b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e8d1b6",
  null
  
)

export default component.exports